var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSuccessIcon = function SvgSuccessIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 0C11.217 0 0 11.217 0 25s11.217 25 25 25 25-11.217 25-25S38.783 0 25 0Zm0 47.778C12.439 47.778 2.222 37.56 2.222 25 2.222 12.439 12.44 2.222 25 2.222 37.561 2.222 47.778 12.44 47.778 25c0 12.561-10.217 22.778-22.778 22.778Zm12.45-31.34a1.113 1.113 0 0 1 0 1.573L21.894 33.567a1.107 1.107 0 0 1-1.567-.006l-7.777-7.778a1.113 1.113 0 0 1 0-1.572 1.113 1.113 0 0 1 1.572 0l6.99 6.995 14.771-14.773a1.102 1.102 0 0 1 1.567.006Z",
    fill: "#162D3D",
    fillRule: "nonzero"
  })));
};
export default SvgSuccessIcon;